import NullTableRegion from "./NullTableRegion";
import TableRegion from "./TableRegion";
import TableRegionChangeEvent from "./TableRegionChangeEvent";

export default class SelectionController{
    constructor(){
        this.selectedRegion = NullTableRegion;
        this.selectionAnchor = null;
        this.listeners = [];
    }

    /**
     * Subscribe specified listener to change selection notification.
     *
     * @param listener listener
     */
    addSelectionChangeListener(listener)
    {
        this.listeners.push(listener);
    }

    fireSelectionChangeEvent(oldSelection)
    {
        var selectionChangeEvent = new TableRegionChangeEvent(oldSelection, this.getSelection());
        for (var i = 0; i < this.listeners.length; i++)
            this.listeners[i].call(this.listeners[i], selectionChangeEvent);
    }

    /**
     * @return {Boolean} true if selection not null, otherwise false.
     */
    hasSelection()
    {
        return this.selectedRegion !== NullTableRegion;
    }

    /**
     * Gets current selection.
     * Note: selection can be empty (Selection.region == null)
     *
     * @return {Selection} selection
     */
    getSelection()
    {
        return this.selectedRegion;
    }

    /**
     * Create new selection.
     *
     * @return {TableRegion} selection
     */
    createSelection(cell)
    {
        return TableRegion.prototype.createFromCells(this.selectionAnchor, cell)
    }

    /**
     * Sets current selection to null.
     * Sets selection anchor to null.
     */
    clearSelection()
    {
        this.selectionAnchor = null;
        if (this.hasSelection())
        {
            var oldSelection = this.getSelection();
            this.selectedRegion = NullTableRegion;
            this.fireSelectionChangeEvent(oldSelection);
        }
    }

    /**
     * Sets selection anchor. Selection calculation performs relatively this cell.
     * Not change current selection.
     * See also changeSelectionTo method.
     *
     * @param {TableCell} cell - table cell
     */
    setSelectionAnchor(cell)
    {
        this.selectionAnchor = cell;
    }

    /**
     * Gets selection anchor. Selection calculation performs relatively this cell.
     *
     * @return {TableCell}
     */
    getSelectionAnchor()
    {
        return this.selectionAnchor;
    }

    /**
     * Selects rectangular region between selection anchor cell and specified cell.
     * Specified cell uses as selection anchor if current selection anchor is null.
     *
     * @param {TableCell} cell - table cell
     */
    changeSelectionTo(cell)
    {
        if (this.selectionAnchor == null)
            this.setSelectionAnchor(cell);
        this.changeSelectionFromAnchorToCell(cell);
    }

    /**
     * Selects rectangular region between specified cells.
     *
     * @param {TableCell} cell1 - table cell
     * @param {TableCell} cell2 - table cell
     */
    changeSelection(cell1, cell2)
    {
        if (this.selectionAnchor == null)
            this.setSelectionAnchor(cell1);
        this.changeSelectionFromAnchorToCell(cell2);
    }

    changeSelectionFromAnchorToCell(cell)
    {
        var oldSelection = this.getSelection();
        this.selectedRegion = this.createSelection(cell);
        this.fireSelectionChangeEvent(oldSelection);
    }


    /**
     * Determines is selection contains cell with specified row and column indexes.
     *
     * @param {Number} rowIdx - row index
     * @param {Number} colIdx - column index
     */
    isSelected(rowIdx, colIdx)
    {
        return this.selectedRegion.contains(rowIdx, colIdx);
    }

    /**
     * Determines is selection contains cell from specified column.
     *
     * @param {Number} colIdx - column index
     */
    isColumnIncludedIntoSelection(colIdx)
    {
        return this.selectedRegion.containsCol(colIdx);
    }

    /**
     * Determines is selection contains cell from specified row.
     *
     * @param {Number} rowIdx - row index
     */
    isRowIncludedIntoSelection(rowIdx)
    {
        return this.selectedRegion.containsRow(rowIdx);
    }
}


// WEBPACK FOOTER //
// ./web/js/table/SelectionController.js